/**
 * Shared desk widgets — operational UI reusable across dashboard, portfolio,
 * trading, and agent surfaces. Props-in only; never invent live balances.
 *
 * Compose with DeskShell / DeskModule for page chrome when needed.
 */

export { WidgetChrome, widgetChromeStyles } from "./WidgetChrome";
export { EquitySummaryWidget } from "./EquitySummaryWidget";
export type { EquitySummaryWidgetProps } from "./EquitySummaryWidget";
export { RiskSummaryWidget } from "./RiskSummaryWidget";
export type { RiskSummaryWidgetProps } from "./RiskSummaryWidget";
export { AgentSupervisionWidget } from "./AgentSupervisionWidget";
export type { AgentSupervisionWidgetProps } from "./AgentSupervisionWidget";
export { MetricStatGridWidget } from "./MetricStatGridWidget";
export type { MetricStatGridWidgetProps } from "./MetricStatGridWidget";
export { PositionsTableWidget } from "./PositionsTableWidget";
export type { PositionsTableWidgetProps } from "./PositionsTableWidget";
export { OrdersTableWidget } from "./OrdersTableWidget";
export type { OrdersTableWidgetProps } from "./OrdersTableWidget";
export { DataFeedReadoutWidget } from "./DataFeedReadoutWidget";
export type { DataFeedReadoutWidgetProps } from "./DataFeedReadoutWidget";
export { DeskFeedModule } from "./DeskFeedModule";
export type { DeskFeedModuleProps } from "./DeskFeedModule";
export { OrderEntryWidget } from "./OrderEntryWidget";
export type {
  OrderEntryWidgetProps,
  OrderEntryPayload,
  OrderSide,
  OrderType,
  TimeInForce,
} from "./OrderEntryWidget";

export {
  formatSignedCurrency,
  formatSignedPercent,
  formatQty,
  finiteDeskNumber,
  resolvePositionSide,
  resolvePositionStatus,
  positionMarkPrice,
  positionAvgPrice,
  positionMarketValue,
  positionUnrealizedPnl,
  tradeDeskHref,
  STALE_MS,
  type PositionSide,
} from "./lib/deskFormat";

export { toWidgetPosition, toWidgetPositions } from "./lib/mapPosition";

export type {
  WidgetLoadState,
  WidgetChromeProps,
  DeskFeedStatus,
  EquitySummaryValues,
  RiskSummaryValues,
  AgentSupervisionCounts,
  DeskMetricItem,
} from "./lib/types";
